import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Info, FileText, X } from 'lucide-react';
import './documents-upload.css';
import InnerHeader from '../../components/InnerHeader';

export default function DocumentsUpload() {
  const [documentType, setDocumentType] = useState('');
  const [documentNo, setDocumentNo] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [selfieFile, setSelfieFile] = useState(null);
  const [reminderExpanded, setReminderExpanded] = useState(true);

  const handleFileUpload = (e, side) => {
    const file = e.target.files[0];
    if (file) {
      const fileData = {
        name: file.name,
        size: (file.size / 1024).toFixed(2) + ' KB',
        file: file
      };

      if (side === 'front') {
        setFrontFile(fileData);
      } else if (side === 'back') {
        setBackFile(fileData);
      } else if (side === 'selfie') {
        setSelfieFile(fileData);
      }
    }
  };

  const removeFile = (side) => {
    if (side === 'front') {
      setFrontFile(null);
    } else if (side === 'back') {
      setBackFile(null);
    } else if (side === 'selfie') {
      setSelfieFile(null);
    }
  };

  const handleSubmit = () => {
    console.log('Form submitted:', {
      documentType,
      documentNo,
      expiryDate,
      frontFile,
      backFile,
      selfieFile
    });
    alert('Documents submitted successfully!');
  };

  const isFormValid = documentType && documentNo && frontFile && backFile && selfieFile;

  return (
    <div className="documents-container">
      {/* Header */}
      <InnerHeader title="Documents" />
      {/* <div className="documents-header">
        <button className="back-button">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="header-title">Documents</h1>
      </div> */}

      {/* Form Content */}
      <div className="form-content">
        {/* Document Type */}
        <div className="form-group">
          <label className="form-label">Document (Any one)</label>
          <div className="select-wrapper">
            <select 
              className="form-select"
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
            >
              <option value="">Choose document type</option>
              <option value="passport">Passport</option>
              <option value="driving_license">Driving License</option>
              <option value="national_id">National ID Card</option>
              <option value="voter_id">Voter ID Card</option>
            </select>
            <ChevronDown className="select-arrow" size={20} />
          </div>
        </div>

        {/* Document Number */}
        <div className="form-group">
          <label className="form-label">Document No</label>
          <input
            type="text"
            className="form-input"
            value={documentNo}
            onChange={(e) => setDocumentNo(e.target.value)}
            placeholder="Enter document number"
          />
        </div>

        {/* Expiry Date */}
        <div className="form-group">
          <label className="form-label">Expiry date</label>
          <input
            type="date"
            className="form-input"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
          />
        </div>

        {/* Upload Front Side */}
          <p className="upload-title">Upload document photo (Front side)</p>
        <div className="upload-section">
          <input
            type="file"
            id="front-upload"
            className="file-input-hidden"
            accept="image/png,image/jpeg,image/jpg"
            onChange={(e) => handleFileUpload(e, 'front')}
          />
          <label htmlFor="front-upload">
            <span className="upload-button">Upload</span>
          </label>
          <span className="upload-hint">Max 3 MB in JPG or JPEG or PNG</span>
          
          {frontFile && (
            <div className="file-preview">
              <FileText className="file-icon" />
              <div className="file-info">
                <div className="file-name">{frontFile.name}</div>
                <div className="file-size">{frontFile.size}</div>
              </div>
              <button className="remove-file-button" onClick={() => removeFile('front')}>
                <X />
              </button>
            </div>
          )}
        </div>

        {/* Upload Back Side */}
          <p className="upload-title">Upload document photo (Back side)</p>
        <div className="upload-section">
          <input
            type="file"
            id="back-upload"
            className="file-input-hidden"
            accept="image/png,image/jpeg,image/jpg"
            onChange={(e) => handleFileUpload(e, 'back')}
          />
          <label htmlFor="back-upload">
            <span className="upload-button">Upload</span>
          </label>
          <span className="upload-hint">Max 3 MB in JPG or JPEG or PNG</span>
          
          {backFile && (
            <div className="file-preview">
              <FileText className="file-icon" />
              <div className="file-info">
                <div className="file-name">{backFile.name}</div>
                <div className="file-size">{backFile.size}</div>
              </div>
              <button className="remove-file-button" onClick={() => removeFile('back')}>
                <X />
              </button>
            </div>
          )}
        </div>

        {/* Upload Selfie */}
          <p className="upload-title">Upload document photo (Selfie holding document with new your face)</p>
        <div className="upload-section">
          <input
            type="file"
            id="selfie-upload"
            className="file-input-hidden"
            accept="image/png,image/jpeg,image/jpg"
            onChange={(e) => handleFileUpload(e, 'selfie')}
          />
          <label htmlFor="selfie-upload">
            <span className="upload-button">Upload</span>
          </label>
          <span className="upload-hint">Max 3 MB in JPG or JPEG or PNG</span>
          
          {selfieFile && (
            <div className="file-preview">
              <FileText className="file-icon" />
              <div className="file-info">
                <div className="file-name">{selfieFile.name}</div>
                <div className="file-size">{selfieFile.size}</div>
              </div>
              <button className="remove-file-button" onClick={() => removeFile('selfie')}>
                <X />
              </button>
            </div>
          )}
        </div>

        {/* Reminder Section */}
        <div className="reminder-section">
          <div 
            className="reminder-header"
            onClick={() => setReminderExpanded(!reminderExpanded)}
          >
            <div className="reminder-title-wrapper">
              <Info className="info-icon" />
              <span className="reminder-title">Reminder</span>
            </div>
            <div className={`expand-icon ${reminderExpanded ? 'expanded' : ''}`}>
              <ChevronDown size={20} />
            </div>
          </div>
          
          <div className={`reminder-content ${!reminderExpanded ? 'hidden' : ''}`}>
            <ul className="reminder-list">
              <li>Upload JPG or PNG file.</li>
              <li>Upload a photo of the document.</li>
              <li>Please provide clear all of the information present is captured on your documents.</li>
            </ul>
            <p className="reminder-note">
              For secure your security, information can be modified only once/month. Please contact us.
            </p>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="submit-section">
        <button 
          className="submit-button"
          onClick={handleSubmit}
          disabled={!isFormValid}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
